import * as React from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { signInWithCredentials } from '../../actions/authActions';
import { Link } from 'react-router-dom';
import './BasicAuthSignIn.css'
import { REGISTERUSER, RESETPASSWORD } from '../../routes/routes';
import { validateEmail } from './../../constants/validation';
import KPInputTextArea from '../BaseTemplate/SSPCustomComponentLibrary/KPInputTextArea/KPInputTextArea';
import { KEYBOARD_KEY_ENTER } from '../../constants/keyboardkeys';
import { hideModal } from '../../actions/modalActions';

class BasicAuthSignIn extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            email: '',
            password: '',
            submitted: false,
            mailRegex: true,
            hide: true,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.hideSwitch = this.hideSwitch.bind(this);
        this.handlePasswordKeyDown = this.handlePasswordKeyDown.bind(this);
        this.hanldeKeyup = this.hanldeKeyup.bind(this);
    } 

    handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
    }

    handlePasswordKeyDown(e: any) {
        if (e.key === 'Enter') {
            this.handleClick(e);
        } 
    }

    hanldeKeyup(evt) {
        if (evt.keyCode === KEYBOARD_KEY_ENTER) {
            this.handleClick(evt)
        }
    }

    hideSwitch = ev => {
        this.setState({ hide: !this.state.hide })
    }

    handleClick(e: any) {
        const { email } = this.state;

        if (validateEmail.test(email)) {
            this.setState({ mailRegex: true });
            e.preventDefault();
            this.setState({ submitted: true });
            this.props.dispatchAction(hideModal())
            this.props.handleSignInWithCredentials(this.state)
        } else {
            this.setState({ mailRegex: false });
        }
    }

    componentDidMount() {
        window.addEventListener("keydown", this.hanldeKeyup);
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.hanldeKeyup);
    }

    render() {
        const { email, password, submitted, mailRegex, hide } = this.state;
        return (
            <div id="EmailLogIn" onKeyDown={this.hanldeKeyup}>
                <KPInputTextArea
                    id="LoginInputEmail"
                    name="email"
                    type="email"
                    className="mb-15px"
                    label={"Email"}
                    alwaysShowLabel={false}
                    value={this.state.email}
                    notice={(!mailRegex || submitted && !email)}
                    noticeType={"error"}
                    noticeMessage={"Whoops, this email address is invalid"}
                    successTick={false}
                    required={false}
                    readOnly={false}
                    autoFocus={false}
                    minLength={10}
                    maxLength={false}
                    disabled={false}
                    form="mainform"
                    handleChange={(e) => this.handleChange(e)}
                />
              
                <KPInputTextArea
                    id="LoginInputPassword"
                    name="password"
                    type="password"
                    className="mb-15px"
                    label={"Password"}
                    alwaysShowLabel={false}
                    value={this.state.password}
                    notice={false}
                    noticeType={"error"}
                    noticeMessage={"Please provide a password to sign in"}
                    successTick={false}
                    required={false}
                    readOnly={false}
                    autoFocus={false}
                    minLength={10}
                    maxLength={false}
                    disabled={false}
                    form="mainform"
                    handleChange={(e) => this.handleChange(e)}
                />
                <p>Uh-oh, I <Link id="ForgotPassword" className="Uh-oh-I-forgot-my-p mt-2" to={RESETPASSWORD} > forgot my password</Link></p>
                <Button id="btnEmailLogIn" type="button" className="btn btn-solid-red btn-lg mt-20px mobile-mt-10px" onClick={this.handleClick}>
                    Log in
                </Button>
                <div className="mt-2">
                    <p>{this.props.profile.countryId != 157 ? "Not a client yet?" : "Not registered yet?"} <Link className="Uh-oh-I-forgot-my-p" id="SignUp" to={REGISTERUSER} > Sign up now</Link></p>
                </div>
            </div>
        )
    };
}

const mapStateToProps = (state: any) => {
    return {
        authError: state.auth.authError,
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleSignInWithCredentials: (creds: any) => dispatch(signInWithCredentials(creds)),
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BasicAuthSignIn)